var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlienBlueActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 266,
    height: 345,
    viewBox: "0 0 266 345",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4666_72291)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255 276C251 257 250 252.5 226 252.5C220.796 251.482 219.501 252.5 212 251C208.721 209.829 242.419 194.753 238.965 125.909C237.422 95.32 229.949 60.8236 212.641 39.5C192.149 14.2491 162.969 0 129.499 0C98.3838 0 71.6442 11.2891 51.3756 33.5C31.4174 55.3691 19.9997 87.3218 19.9997 120.5C19.9997 209.242 52.9996 220 50.9996 246C50.776 248.907 44.8662 249.755 41.5 251.5C16.9997 251.5 10.2672 265.109 11.0001 281C11.711 296.414 26.1389 307.037 41.5 308.5C52 309.5 63 307.5 67.5 303C68 321.5 90.9984 325 99 325C107 325 123.276 323.5 121 299.5C118.824 286.5 107.825 297.133 115 303C115 318.811 126.605 322.5 146.5 322.5C162.998 321 162.5 316.5 165.5 310.5C165.381 309.729 171.108 320.309 189.499 319C200.999 317.5 211.764 310.216 208 300.5C203.416 288.66 199.5 298.5 205.5 303.5C210.346 306.853 221 306 230.5 306C248 304.5 255.668 288.131 255 276Z",
    fill: "#5BF5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.975 278.99C244.84 256.227 236.401 265.636 216.071 261.278C211.406 260.279 204.45 260.3 204.443 260.286C188.75 219.882 231.137 202.005 228.041 134.48C226.657 104.476 222.912 68.4591 207.397 47.5436C189.028 22.7761 159.959 10 129.955 10C102.063 10 73.2653 22.077 55.0962 43.8628C37.2054 65.3132 29.7295 96.2298 29.7295 128.773C29.7295 215.816 69.5416 223.377 59.8828 255.286C59.7758 255.642 54.5113 258.096 51.4938 259.808C38.1327 267.398 16.347 252.789 21.8826 285.71C23.8729 297.573 43.7896 302.138 59.1338 296.553C66.8308 293.749 75.8405 286.174 75.5837 287.493C71.6317 308.002 85.7275 316.027 96.9913 316.027C108.255 316.027 118.413 311.034 116.373 287.493C116.359 287.365 117.971 287.693 117.971 287.943C117.971 303.451 123.842 313.887 141.676 313.887C157.648 313.887 163.461 303.694 161.129 287.493C161.022 286.737 167.007 311.162 183.492 309.878C192.345 309.186 204.878 302.431 201.504 292.901C197.395 281.287 202.146 292.066 202.574 292.394C206.919 295.683 212.732 297.773 220.907 297.773C236.53 297.766 246.574 290.889 245.975 278.99Z",
    fill: "#C0D3F8",
    stroke: "black",
    strokeWidth: 7.13351,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.756 102.773C186.439 98.1715 175.725 101.396 197.703 87.7852",
    stroke: "#232E2E",
    strokeWidth: 7.13351,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5371 86C72.9526 97.0569 75.4921 94.4746 96.8927 101.344",
    stroke: "#232E2E",
    strokeWidth: 7.13351,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.349 142.283C191.275 142.283 197.701 135.857 197.701 127.931C197.701 120.004 191.275 113.578 183.349 113.578C175.422 113.578 168.996 120.004 168.996 127.931C168.996 135.857 175.422 142.283 183.349 142.283Z",
    fill: "#FEFEFC",
    stroke: "#232E2E",
    strokeWidth: 7.13351,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9913 141.213C83.918 141.213 90.3439 134.787 90.3439 126.86C90.3439 118.934 83.918 112.508 75.9913 112.508C68.0646 112.508 61.6387 118.934 61.6387 126.86C61.6387 134.787 68.0646 141.213 75.9913 141.213Z",
    fill: "#FEFEFC",
    stroke: "#232E2E",
    strokeWidth: 7.13351,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.543 177.536C164.375 169.989 176.123 165.002 185.19 163.718C196.318 162.149 203.716 164.196 204.265 170.181C204.729 175.203 201.704 183.271 185.618 185.069C176.509 186.082 168.277 183.585 166.543 177.536Z",
    fill: "#F6FBD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9591 170.374C52.0791 163.169 62.8007 162.106 72.2954 163.583C81.783 165.06 89.4372 168.983 88.3173 176.181C87.1973 183.386 76.0619 186.253 67.4518 184.848C55.6173 182.537 49.8391 177.579 50.9591 170.374Z",
    fill: "#F6FBD5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4666_72291",
    x: 0.947266,
    y: 0,
    width: 264.094,
    height: 345,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4666_72291"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4666_72291",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlienBlueActive);
export default __webpack_public_path__ + "static/media/alien_blue_active.74f7e64ba6c00d693e28feb6434806aa.svg";
export { ForwardRef as ReactComponent };